<small class="debug">{{me}}</small>
<div style="position: absolute; right: 0px; top: 8px;">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <app-local-diag [setLargeMode]="false"></app-local-diag>
    <app-theme-selector [hideText]="true"></app-theme-selector>
    <div class="hide-gt-md">
      <button class="headers" mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon>menu</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        @for (main of jsonMenuList; track main) {
          <button mat-menu-item (click)="openUrl(main.link)" class="montserratFamily">
            {{main.name}}
          </button>
        }
      </mat-menu>
    </div>
  </div>
</div>
<ul class="d-flex-center">
  @for (item of jsonMenu; track item) {
    <li>
      @if (!item.buttonized) {
        <span class="hide-lt-lg">
          <button class="headers" mat-button [matMenuTriggerFor]="menu">{{item.name}}</button>
          <mat-menu #menu="matMenu">
            @for (main of item[item.name]; track main) {
              <button mat-menu-item (click)="openUrl(main.link)" class="montserratFamily">
                {{main.name}}
              </button>
            }
          </mat-menu>
        </span>
      }
      @if (item.buttonized) {
        <span class="hide-lt-md">
          @for (sub of item[item.name]; track sub) {
                <div (click)="openUrl(sub.link)" [ngClass]="
                    {
                        gray: sub.name === 'live chat' && !liveChatStatus,
                        green: sub.name === 'live chat' && liveChatStatus,
                        orange: sub.name === 'get started',
                        blue: sub.name === 'login'
                    }" class=" buttonized">
              <span>{{sub.name}}</span>
            </div>
          }
        </span>
      }
    </li>
  }
</ul>

